import { defineMessages } from "react-intl";

const PREFIX = "BulkExportPage";
export default defineMessages({
  titlePage: {
    id: `${PREFIX}.titlePage`,
    defaultMessage: "Bulk export",
  },
  dataSourcesTitle: {
    id: `${PREFIX}.dataSourcesTitle`,
    defaultMessage: "Data source selection",
  },
  measuringTitle: {
    id: `${PREFIX}.measuringTitle`,
    defaultMessage: "Measurement selection",
  },
  formatFileTitle: {
    id: `${PREFIX}.formatFileTitle`,
    defaultMessage: "Export Settings",
  },
  summaryTitle: {
    id: `${PREFIX}.summaryTitle`,
    defaultMessage: "Summary",
  },
  btnPrevious: {
    id: `${PREFIX}.btnPrevious`,
    defaultMessage: "Previous",
  },
  btnNext: {
    id: `${PREFIX}.btnNext`,
    defaultMessage: "Next",
  },
  btnFinish: {
    id: `${PREFIX}.btnFinish`,
    defaultMessage: "Finish",
  },
  exportFormatLabel: {
    id: `${PREFIX}.exportFormatLabel`,
    defaultMessage: "Export formats",
  },
  exportFormatPivotExcel: {
    id: `${PREFIX}.exportFormat.pivotExcel`,
    defaultMessage: "Pivot Excel (*.xlsx)",
  },
  exportFormatFlatFileCsv: {
    id: `${PREFIX}.exportFormat.flatFile.csv`,
    defaultMessage: "Flat File (*.csv)",
  },
  exportFormatFlatFileTxt: {
    id: `${PREFIX}.exportFormat.flatFile.txt`,
    defaultMessage: "Flat File (*.txt)",
  },
  emailLabel: {
    id: `${PREFIX}.exportFormat.emailLabel`,
    defaultMessage: "E-mail",
  },
  fieldIsRequired: {
    id: `${PREFIX}.exportFormat.fieldIsRequired`,
    defaultMessage: "The field is required",
  },
  emailNotInSystem: {
    id: `${PREFIX}.exportFormat.emailNotInSystem`,
    defaultMessage: "Sorry, this email can not be registered in the system.",
  },
  checkCorrectness: {
    id: `${PREFIX}.exportFormat.checkCorrectness`,
    defaultMessage: "Please, check the correctness of the entered data",
  },
  summaryConditions: {
    id: `${PREFIX}.summary.conditions`,
    defaultMessage: "Conditions",
  },
  summaryConfiguration: {
    id: `${PREFIX}.summary.configuration`,
    defaultMessage: "Configuration",
  },
  summaryExportSettings: {
    id: `${PREFIX}.summary.exportSettings`,
    defaultMessage: "Export Settings",
  },
  summaryErrors: {
    id: `${PREFIX}.summary.exportErrors`,
    defaultMessage: "Errors",
  },
  measurementSearchNoData: {
    id: `${PREFIX}.measurement.search.noData`,
    defaultMessage: "Sorry, we couldn't find any results for this search. Please change your search query.",
  },
  measurementSearchPlaceholder: {
    id: `${PREFIX}.measurement.search.placeholder`,
    defaultMessage: "Search",
  },
  measurementControlSelectAll: {
    id: `${PREFIX}.measurement.control.selectAll`,
    defaultMessage: "Select all",
  },
  measurementControlDeselectAll: {
    id: `${PREFIX}.measurement.control.deselectAll`,
    defaultMessage: "Deselect all",
  },
  measurementControlExpandAll: {
    id: `${PREFIX}.measurement.control.expandAll`,
    defaultMessage: "Expand all",
  },
  measurementControlCollapseAll: {
    id: `${PREFIX}.measurement.control.collapseAll`,
    defaultMessage: "Collapse all",
  },
  measurementCountriesError: {
    id: `${PREFIX}.measurement.countries.error`,
    defaultMessage:
      "Please be careful at multiple selection of countries (e.g. EU-27, EU-15, World) in order to avoid double counting.",
  },
  exportSettingsXlsxError: {
    id: `${PREFIX}.measurement.countries.error`,
    defaultMessage:
      "Selection of Pivot Excel (.xlsx) export format will not retreive any data for aggregated items. In case you would like to obtain such values directly from the system, please choose any other export format of your preference.",
  },
  summaryErrorsEmail: {
    id: `${PREFIX}.measurement.countries.error`,
    defaultMessage: "Please, specify a valid e-mail adress",
  },
  measurementConfigurationTab: {
    id: `${PREFIX}.measurement.configuration.tab`,
    defaultMessage: "Configuration",
  },
  snackBarTitle: {
    id: `${PREFIX}.snackBar.title`,
    defaultMessage: "Now we are preparing a file for you. After several time you can load it on your PC",
  },
  finishPageTitle: {
    id: `${PREFIX}.finishPage.title`,
    defaultMessage:
      "Right now we are preparing a file for you. It will be sent on your email in maximum 10 minutes. Thank you for patience",
  },
  finishPageBtnCreateNewExport: {
    id: `${PREFIX}.finishPage.btn.newExport`,
    defaultMessage: "Create a new export",
  },
  finishPageBtnContinueSelection: {
    id: `${PREFIX}.finishPage.btn.continueSelection`,
    defaultMessage: "Continue selection",
  },
  summaryZeroChecked: {
    id: `${PREFIX}.summary.zeroChecked`,
    defaultMessage: "Required: Please select one or more dimension fields",
  },
  summaryBigNumberOfRecords: {
    id: `${PREFIX}.summary.bigNumberOfRecords`,
    defaultMessage:
      "You have exceeded the limit of bulk export to xls/xlsx. It is not possible to have xls/xlsx bulk exports if the records are more than 1,048,574. You could split your selection and make multiple exports within the limits or you could export your selection to txt or csv",
  },
});
